/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { StyledBody, StyledHeader } from './styles';
import { BoldV2, StyledModalV2 } from './styles';
import { StyledBodyV2, SubmitContainerV2 } from '../AddWellnessInitiative/styles';
import { UserButtonV2 } from '../EngagementSection/styles';
import { DeleteFiledIcon } from '../../utils/icons';
import {
  DepartmentStyledInputContainer,
  DepartmentStyledInputWrapper,
  DepartmentStyledInputNewP1,
  DepartmentDeleteIconWrapper,
  AddDepartmentButton,
  SaveUpdatesButton,
  DepartmentTitle,
  DepartmentHeader,
  DepartmentStyledModal,
  DepartmentContainer,
  CloseButton,
  
  
} from './departmentStyles';
import { Divider } from '../RecogntionAdmin/styles';

class AddDepartmentPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          department: '',
          id: ''
        }
      ],
      deleted: [],
      showDeleteDepartmentPopUp: false,
      currentId: null,
      currentDepartmentName: null
    }
  }

  componentDidMount() {
    const { data } = this.props;
  
    if (data && Array.isArray(data)) {
      const dept = data.filter((obj) => obj.id !== null);
      this.setState({
        data: dept
      });
    }
  }

  onChangeInput = (e, index) => {
    const duplicateData = this.state.data;
    duplicateData[index][e.target.name] = e.target.value;
    duplicateData[index]["change"] = true;
    this.setState({
      data: duplicateData,
    })
  }

  onToggleDeleteDepartmentPopup = (details) => {
    this.setState({ showDeleteDepartmentPopUp: !this.state.showDeleteDepartmentPopUp, currentId: details?.id, currentDepartmentName: details?.department });
  };

  showInputContainer = () => (
    (
      <div>
        <DepartmentTitle>All Departments</DepartmentTitle>
        <DepartmentContainer>
          {this.state.data.map((details, index) => (
            <DepartmentStyledInputWrapper key={index} isDepartmentPopup>
              <DepartmentStyledInputContainer isDepartmentPopup>
                <DepartmentStyledInputNewP1 
                  isDepartmentPopup
                  width='100%' 
                  type="text" 
                  placeholder='Enter Department' 
                  name='department' 
                  value={details.department}
                  onChange={(e) => this.onChangeInput(e, index)} 
                /> 
                <DepartmentDeleteIconWrapper 
                  isDepartmentPopup
                  onClick={() => this.onToggleDeleteDepartmentPopup(details, index)} 
                >
                  {DeleteFiledIcon()}
                </DepartmentDeleteIconWrapper> 
              </DepartmentStyledInputContainer>
            </DepartmentStyledInputWrapper>
          ))}
          <AddDepartmentButton onClick={this.addEmployeeInputContainer}>
            Add Department
          </AddDepartmentButton>
          <Divider isMargin={"12px 0px 4px 0px"}></Divider>
        </DepartmentContainer>
      </div>
    )
  )

  handleDelete = () => {
    const newData = this.state.data.filter((obj) => obj.id != this.state.currentId)
    let deletearray = this.state.deleted;
    this.state.currentId && deletearray.push(this.state.currentId)
    this.setState({ data: newData, showDeleteDepartmentPopUp: !this.state.showDeleteDepartmentPopUp, deleted: deletearray })
  }

  deleteDepartmentPopup = () => (
    (<StyledModalV2
      show={this.state.showDeleteDepartmentPopUp ? true : false}
      onHide={this.onToggleDeleteDepartmentPopup}
      dialogClassName={'delete-popup'}
      backdropClassName='drop-back'
    >
      <StyledBodyV2>
        <BoldV2>
          Are you sure you want to <span className='name-in-popup'>Delete<br />
            this Department ({this.state.currentDepartmentName})?</span>
          <div className="subContent">
            Once you delete the department, then it<br />
            will be removed for all users in Woliba.<br />
            Also, users with this department would<br />
            no longer have a department so you&apos;d<br />
            need to update those users.
          </div>
        </BoldV2>
        <SubmitContainerV2>
          <UserButtonV2
            radius="5px"
            bgColor="#FD7175"
            width="125px"
            height="50px"
            fontSize="18px"
            Align={1}
            float={1}
            marginLeft="0px"
            onClick={() => this.handleDelete()}
            font="Rubik"
            capitalize="capitalize"
            marginRight="15px"
          >
            {"Delete"}
          </UserButtonV2>
          <UserButtonV2
            radius="5px"
            bgColor="none"
            width="125px"
            height="50px"
            fontSize="18px"
            Align={1}
            float={1}
            marginLeft="0px"
            onClick={this.onToggleDeleteDepartmentPopup}
            outline={0}
            font="Rubik"
            capitalize="capitalize"
            textColor="#9C9C9C"
            border="border: 2px solid #9C9C9C"
            boxSizing="border-box"
          >
            cancel
          </UserButtonV2>
        </SubmitContainerV2>
      </StyledBodyV2>
    </StyledModalV2>
    )
  )

  addEmployeeInputContainer = () => {
    const duplicateData = this.state.data;
    const obj = {
      department: '',
    }
    duplicateData.push(obj);
    this.setState({
      data: duplicateData
    })
  }

  addDepartmentButton = () => {
    const info = {};
    const data = this.state.data.filter((obj) => obj.change === true);
    data.map((item) => {
      delete item.change
    })
    info['company_id'] = this.props.companyId
    info['department'] = data
    this.props.showModalPopUp()
    this.props.fetchEditDepartmentApi(info, { "delete_department": this.state.deleted, "delete_location": [] })
  };

  render() {
    const { show } = this.props;
    return (
      <DepartmentStyledModal show={show} onHide={this.props.showModalPopUp}>
        <StyledHeader closeButton>
          <DepartmentHeader>
            <span>Add/Edit Department</span>
          
            <CloseButton onClick={this.props.showModalPopUp}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7.9047 7.0001L13.8421 0.952766C14.0871 0.703686 14.0423 0.336191 13.7427 0.132027C13.4431 -0.0709698 13.0028 -0.035387 12.7578 0.21486L7.0003 6.07903L1.2421 0.214276C0.996403 -0.0359703 0.556103 -0.0715531 0.257203 0.131444C-0.0423974 0.336191 -0.0864976 0.703103 0.157803 0.952183L6.0959 7.0001L0.158503 13.0474C-0.0864974 13.2965 -0.0416975 13.664 0.257903 13.8682C0.388103 13.9563 0.544203 14 0.700303 14C0.903303 14 1.1042 13.9271 1.2428 13.7859L7.0003 7.92117L12.7585 13.7853C12.8971 13.9265 13.098 13.9994 13.301 13.9994C13.4571 13.9994 13.6132 13.9563 13.7434 13.8676C14.043 13.6628 14.0871 13.2959 13.8428 13.0468L7.9047 7.0001Z" fill="#F37A65"/>
              </svg>
            
            </CloseButton>
          </DepartmentHeader>
        </StyledHeader>
        <Divider isMargin={"4px 0px"}></Divider>
        <StyledBody>
          {this.showInputContainer()}
          
          <SaveUpdatesButton onClick={this.addDepartmentButton}>
            Save Updates
          </SaveUpdatesButton>
        </StyledBody>
        {this.deleteDepartmentPopup()}
      </DepartmentStyledModal>
    );
  }
}

AddDepartmentPopup.propTypes = {
  show: PropTypes.bool,
  showModalPopUp: PropTypes.func,
  postAddEmployee: PropTypes.func,
  companyId: PropTypes.number,
  companyAuthDetails: PropTypes.func,
  fetchEditDepartmentApi: PropTypes.func,
  data: PropTypes.array
}

export default AddDepartmentPopup;